<template>
	<div class='journal-lpo'>

		<journal-toolbar></journal-toolbar>

		<div class='table-container'>
			<journal-table></journal-table>
		</div>

	</div>
</template>

<script>	
	import JournalToolbar from './JournalLpo__toolbar';
	import JournalTable from './JournalLpo__table';
		
	export default {
		name: 'JournalLpo',

		components: {
			JournalToolbar,
			JournalTable,
		},

		created() {
			this.$store.dispatch('journalLpo/getJournalLpo');
		}
	};
</script>

<style scoped>
	.journal-lpo {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.table-container {
		flex: 1;
		overflow-y: auto;
	}
</style>